var Tabulator = require('tabulator-tables')

Tabulator.prototype.extendModule("format", "formatters", {
    htmlWrapFormatter: function(cell, formatterParams){
        cell.getElement().style.whiteSpace = "pre-wrap";
        return this.emptyToSpace(cell.getValue());
    },
});